<template>

	<div class="NS-threeDropdown threeD--wrap">
		<div
			:class="{active: isOpen}"
			class="NS-threeDropdown__switch drop"
			@click.prevent="switchOpen"
		>
			<i class="fa fa-globe"></i>{{ $t(locale) }}
		</div>

		<ul
			class="NS-threeDropdown__item--wrap threeD__animations left flex direction-column"
			:class="{active: isOpen}"
		>
			<li
				class="NS-threeDropdown__item flex align-center"
				v-for="(item, index) in localeList"
				:key="index"
				:style="{order: item.active ? -1 : 0}"
				@click.prevent="changeLocale(item)"
			>
				<i
					class="fa fa-check"
					v-if="item.active"
				></i>{{ $t(item.lang) }}
			</li>
		</ul>
	</div>

</template>

<script>

	import {threeDropdown} from "@/plugin/threeDropdown";
	import {setCookie} from "@/plugin/cookie";

	export default {
		data() {
			return {
				localeList: [
					{
						active: false,
						locale: 'ru',
						lang: 'footer.lang.ru'
					},
					{
						active: false,
						locale: 'en',
						lang: 'footer.lang.en'
					}
				],
			}
		},
		computed: {
			locale() {
				this.setActiveLocale(this.$i18n.locale);
				return this.localeList.find(el => el.locale === this.$i18n.locale).lang
			}
		},
		methods: {
			async changeLocale(e) {
				this.switchOpen();
				this.$i18n.locale = e.locale;
				this.setCookie('appLang', e.locale, {domain: '.netpeaksoftware', path: '/'});
				await this.$store.dispatch('getBlogPosts');
				this.$router.push(e.locale === 'en' ? '/' : '/ru')
			},
			setActiveLocale(locale) {
				this.localeList.forEach(el => el.active = false);
				this.localeList.find(el => el.locale === locale).active = true;
			}
		},
		mixins: [threeDropdown, setCookie]
	}

</script>